import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getProduct = gql`
  ${seoFragment}
  query GetProduct($slug: [String], $site: [String]) {
    entry(slug: $slug) {
      typeHandle
      ... on vino_Entry {
        id
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        title
        slug
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          srcset(sizes: ["750w", "1000w"])
          width
          height
          title
        }
        sezioneBio
        filtroCategoriaProdottoVino(site: $site) {
          title
          slug
          ... on categoriaProdottoVino_Category {
            key
          }
        }
        filtroCategoriaLievitoVino(site: $site) {
          title
          slug
          ... on categoriaLievitoVino_Category {
            key
          }
        }
        filtroTipologiaVino(site: $site) {
          title
          slug
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        icone
        disponibilitaFormatoProdotto(site: $site) {
          title
          ... on formatiProdotti_Entry {
            id
            image {
              id
              url
              width
              height
              title
            }
          }
        }
        schedaTecnica {
          url
        }
        schedaTecnicaEn {
          url
        }
        schedaTecnicaEs {
          url
        }
        schedaTecnicaFr {
          url
        }
        applicazioni
        applicazioniEn
        applicazioniEs
        applicazioniFr
        specificheTecniche
        specificheTecnicheEn
        specificheTecnicheEs
        specificheTecnicheFr
        modalitaDuso(site: $site) {
          url
          title
          slug
        }
        smaltimento
        linkAcquista
        proposte {
          id
          title
          ... on vino_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroTipologiaVino(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            slug
          }
        }
      }
      ... on birra_Entry {
        id
        localized {
          slug
          language
        }
        seo {
          ...SeoFragment
        }
        title
        slug
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          width
          srcset(sizes: ["750w", "1000w"])
          height
          title
        }
        sezioneBio
        filtroCategoriaLievitoBirra(site: $site) {
          title
          slug
          ... on categoriaLievitoBirra_Category {
            key
          }
        }
        filtroStiliBirra(site: $site) {
          title
          slug
        }
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        icone
        disponibilitaFormatoProdotto(site: $site) {
          title
          ... on formatiProdotti_Entry {
            id
            image {
              id
              url
              width
              height
              title
            }
          }
        }
        schedaTecnica {
          url
        }
        schedaTecnicaEn {
          url
        }
        schedaTecnicaEs {
          url
        }
        schedaTecnicaFr {
          url
        }
        applicazioni
        applicazioniEn
        applicazioniEs
        applicazioniFr
        specificheTecniche
        specificheTecnicheEn
        specificheTecnicheEs
        specificheTecnicheFr
        modalitaDuso(site: $site) {
          url
          title
          slug
        }
        smaltimento
        linkAcquista
        proposte {
          id
          title
          ... on birra_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroStiliBirra(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
            slug
          }
        }
      }
      ... on prodottoPanificati_Entry {
        id
        seo {
          ...SeoFragment
        }
        title
        slug
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          srcset(sizes: ["750w", "1000w"])
          width
          height
          title
        }
        sezioneBio
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        schedaTecnica {
          url
        }
        schedaTecnicaEn {
          url
        }
        schedaTecnicaEs {
          url
        }
        schedaTecnicaFr {
          url
        }
        icone
        disponibilitaFormatoProdotto(site: $site) {
          title
          ... on formatiProdotti_Entry {
            id
            image {
              id
              url
              width
              height
              title
            }
          }
        }
        applicazioni
        applicazioniEn
        applicazioniEs
        applicazioniFr
        specificheTecniche
        specificheTecnicheEn
        specificheTecnicheEs
        specificheTecnicheFr
        modalitaDuso(site: $site) {
          url
          title
          slug
        }
        smaltimento
        linkAcquista
        proposte {
          id
          title
          ... on vino_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroTipologiaVino(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
          ... on birra_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroStiliBirra(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
        }
      }
      ... on prodottoAgricoltura_Entry {
        id
        seo {
          ...SeoFragment
        }
        title
        slug
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          width
          srcset(sizes: ["750w", "1000w"])
          height
          title
        }
        sezioneBio
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        icone
        schedaTecnica {
          url
        }
        schedaTecnicaEn {
          url
        }
        schedaTecnicaEs {
          url
        }
        schedaTecnicaFr {
          url
        }
        disponibilitaFormatoProdotto(site: $site) {
          title
          ... on formatiProdotti_Entry {
            id
            image {
              id
              url
              width
              height
              title
            }
          }
        }
        applicazioni
        applicazioniEn
        applicazioniEs
        applicazioniFr
        specificheTecniche
        specificheTecnicheEn
        specificheTecnicheEs
        specificheTecnicheFr
        modalitaDuso(site: $site) {
          url
          title
          slug
        }
        smaltimento
        linkAcquista
        proposte {
          id
          title
          ... on vino_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroTipologiaVino(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
          ... on birra_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroStiliBirra(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
        }
      }
      ... on prodottoNutraceutica_Entry {
        id
        seo {
          ...SeoFragment
        }
        title
        slug
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          width
          srcset(sizes: ["750w", "1000w"])
          height
          title
        }
        sezioneBio
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        icone
        schedaTecnica {
          url
        }
        schedaTecnicaEn {
          url
        }
        schedaTecnicaEs {
          url
        }
        schedaTecnicaFr {
          url
        }
        disponibilitaFormatoProdotto(site: $site) {
          title
          ... on formatiProdotti_Entry {
            id
            image {
              id
              url
              width
              height
              title
            }
          }
        }
        applicazioni
        applicazioniEn
        applicazioniEs
        applicazioniFr
        specificheTecniche
        specificheTecnicheEn
        specificheTecnicheEs
        specificheTecnicheFr
        modalitaDuso(site: $site) {
          url
          title
          slug
        }
        smaltimento
        linkAcquista
        proposte {
          id
          title
          ... on vino_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroTipologiaVino(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
          ... on birra_Entry {
            id
            typeHandle
            sezioneBio
            descrizioneProdotto
            descrizioneProdottoEn
            descrizioneProdottoEs
            descrizioneProdottoFr
            filtroStiliBirra(site: $site) {
              title
            }
            portrait: immagine
              @transform(format: "webp", width: 1200, height: 1400) {
              id
              url
              width
              srcset(sizes: ["750w", "1000w"])
              height
              title
            }
            slug
          }
        }
      }
    }
    entries(type: ["vino", "birra"]) {
      id
      ... on vino_Entry {
        title
        typeHandle
        sezioneBio
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        filtroTipologiaVino(site: $site) {
          title
        }
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          srcset(sizes: ["750w", "1000w"])
          width
          height
          title
        }
        slug
        filtroCategoriaProdottoVino(site: $site) {
          title
          slug
          ... on categoriaProdottoVino_Category {
            key
          }
        }
      }
      ... on birra_Entry {
        title
        typeHandle
        sezioneBio
        descrizioneProdotto
        descrizioneProdottoEn
        descrizioneProdottoEs
        descrizioneProdottoFr
        filtroStiliBirra(site: $site) {
          title
        }
        portrait: immagine
          @transform(format: "webp", width: 1200, height: 1400) {
          id
          url
          width
          srcset(sizes: ["750w", "1000w"])
          height
          title
        }
        slug
        filtroCategoriaLievitoBirra(site: $site) {
          title
          slug
          ... on categoriaLievitoBirra_Category {
            key
          }
        }
      }
    }
  }
`
